import React from "react";

const SliderCard = ({ item, onClick }) => {
  return (
    <div className="state-card" onClick={onClick} style={{ cursor: "pointer" }}>

      {/* Background Image */}
      <img src={item.image} className="state-bg" alt={item.name} />

      {/* Logo icon */}
      <div className="state-badge">
        <img src={item.icon} alt="Badge" />
      </div>

      {/* Star */}
      {item.isStarred && (
        <div className="state-star">
          <img src={item.staricon} alt="star" />
        </div>
      )}

      {/* Tick */}
      {item.isSelected && (
        <div className="state-tick">
          <i className="fa-solid fa-check"></i>
        </div>
      )}

      {/* Title */}
      <div className="state-content">
        <h5>{item.name}</h5>

        {/* subtitle → either capital OR location */}
       {item.location && <p>({item.location})</p>}
      </div>
    </div>
  );
};

export default SliderCard;
